import Vue from 'vue';
import toast from '../components/Toast.vue';

function getOrCreateToastContainer () {
  const existingContainer = document.getElementById('toast-container');

  if (existingContainer) {
    return existingContainer;
  }

  const container = document.createElement('div');
  container.id = 'toast-container';
  document.body.appendChild(container);
  return container;
}

export default (_, inject) => {
  if (process.browser) {
    inject('toast', async (options) => {
      const component = new (Vue.extend(toast))({ propsData: { show: false } });

      component.$mount();
      getOrCreateToastContainer().appendChild(component.$el);
      const result = await component.open(options);
      Vue.set(component.internalValues, 'show', false);
      component.$el.remove();

      return result;
    });
  } else {
    inject('toast', () => {
      console.warn('Toast called server-side, this has no effect.');
      return Promise.resolve(false);
    });
  }
};
